export default "__VITE_ASSET__BpRVnUXn__"